import { render, staticRenderFns } from "./FontWeight.vue?vue&type=template&id=19defb4e&"
import script from "./FontWeight.vue?vue&type=script&lang=js&"
export * from "./FontWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports